import React from 'react'
import { Typography } from '@mui/material'
import classes from './Heading.module.css'

const Heading = (props) => {
  return (
    <Typography
      className={classes.heading1}
      mt={2}
      mb={3}
      component="h2"
      sx={{
        color: "#242424",
        textAlign: 'center',
        fontSize: '18px'
      }}
      {...props}
    >
      {props.text}
    </Typography>
  )
}

export default Heading